import React from "react";
import { FaAppStoreIos } from "react-icons/fa";
import { AiTwotoneAppstore } from "react-icons/ai";
import { SiAntdesign } from "react-icons/si";
import { BiCodeAlt } from "react-icons/bi";
import ServicesCard from "./ServicesCard";

const MyServices = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2">
      <ServicesCard
        icons={<BiCodeAlt />}
        title="Web Development"
        subTitle="Experienced in building modern web applications with React and Next.js, and developing robust back-ends using C#."
      />
      <ServicesCard
        icons={<SiAntdesign />}
        title="Web Design"
        subTitle="Skilled in creating visually appealing, user-friendly designs, focusing on responsive layouts and modern aesthetics."
      />
      <ServicesCard
        icons={<AiTwotoneAppstore />}
        title="Full Stack"
        subTitle="Proficient in both front-end and back-end technologies, building dynamic applications with seamless user experiences and robust server-side logic."
      />
      <ServicesCard
        icons={<FaAppStoreIos />}
        title="SEO"
        subTitle="Expert in optimizing websites for search engines, improving rankings, and driving organic traffic through targeted strategies."
      />
    </div>
  );
};

export default MyServices;
